import { Component } from 'react';
import Image from 'Components/Common/Image';
import {  formatDateTime } from 'Components/Common/TimeStamp';
import { toast as toastr } from 'react-toastify';
import { getUserInfo, wipeUserData } from '../../../Helpers/queries';
import { getFormattedText } from '../../../Helpers/index';
import Popup from 'Components/Common/PopUp';
import { ClearAutoLogout, AutoLogout } from '../../../Helpers/AutoLogout';
import routesPath from 'Constants/routes.constants';

export default class UserDetails extends Component{
    constructor(props){
        super(props)
            this.state={
                toShow:'Contacts',
                userDetails:[],
                filtered:[],
                userRejectType: 0,
                deletepopup: false,
            }
    }
    
    componentDidMount(){
      const { usersList, match: { params: { id: userName } } } = this.props;
      this.setState({ userName: userName })
      let isExists = false;
      usersList.some((e)=>{
        if(e.username === userName) {
          isExists = true; 
          this.setState({ userDetails:e })
        }
      })
      if(!isExists) return this.props.history.push(`/User/UserManagement`);
      ClearAutoLogout();
      getUserInfo(`/users/info?username=${ userName }`)
      .then(response => response.json())
      .then( res => {
        AutoLogout();
        const { data = [] } = res;
        const { userDetails } = this.state;
        if(data.length > 0) {
          userDetails[ 'mobile' ] = data[ 0 ].mobile;
          const date = new Date(data[ 0 ].lastLoginDate * 1000);
          userDetails[ 'lastLoginDate' ] = date.toISOString();
          this.setState({ userDetails: userDetails })
        }
      })
      .catch((error) => {
        AutoLogout();
        console.log('error', error)
      });
      
    }

    componentDidUpdate(prevProps, prevState) {
      this.handleUsersList(prevProps);
    }

    /**
     * handle usersContactlist and finds the current user to show on top.
     */
    handleUsersList = (prevProps) => {
      const { userContactsList, match: { params: { id: userName } } } = this.props;
      if(prevProps.match.params.id !== userName && this.state.userDetails.username !== userName) {
        this.setState({ userName: userName })
        return userContactsList.some((e)=>{
          e.username === userName && this.setState({ userDetails:e })
        })
      }
    }

    handleClick = (event) => {
        this.setState({
            toShow: event.target.name
        })
    }

    handleUserDetails = (data) => {
      this.props.userContactsList.some((e)=>{
        e.username === data && this.setState({ userDetails:e })
      })
    }

    removeUser = (type) => {
      const deactivateBtn = document.getElementById('deactivate-user');
      if(type === 0) {
        this.setState({ userRejectType: 1 });
        deactivateBtn.classList.remove('btn_error')
        deactivateBtn.classList.add('btn_approve')
        deactivateBtn.innerHTML = 'Activate User';
        toastr.success('success');
      }else if(type === 1) {
        deactivateBtn.classList.remove('btn_approve')
        deactivateBtn.classList.add('btn_error')
        this.setState({ userRejectType: 0 });
        deactivateBtn.innerHTML = 'Deactivate User';
        toastr.success('success');
      }
    }

    clearUserData = () => {
      ClearAutoLogout();
      wipeUserData('/users/wipe?username='+this.state.userName)
      .then(response => response.json())
      .then( res => {
        AutoLogout();
        const { status, message } = res;
        if(status === 200) {
          toastr.success(message); 
          setTimeout(() => {
            return this.props.history.push(`/User/UserManagement`);
          }, 2000);
        }else {
          toastr.error(message);
        }
      })
      .catch((error) => {
        AutoLogout();
        console.log('error', error)
      });
    }

    handleBack = () => {
      this.props.history.push(routesPath.userManagement);
    }

    handlePopup = () =>{
      this.setState({ deletepopup: true })
    }

    closePopUp = () => {
      this.setState({ deletepopup: false });
    }

    handleDelete = () => {
      this.setState({ deletepopup: false }, () => {
        this.clearUserData()
      })
    };

    render(){
      const { userDetails, deletepopup } = this.state;
      const registeredDate = formatDateTime(userDetails.registeredAt);
      const splitLastLoginDate = userDetails.lastLoginDate && userDetails.lastLoginDate.split('.')
      const lastLoginDate = userDetails.lastLoginDate && formatDateTime(splitLastLoginDate[ 0 ])
        return(
          <>
            <div className='grid pageContainer_inner'>
              <div className='heading-block gap-10'>
                <div className='block_flex'><h4>User Info</h4></div>
              </div>
              <div className='groupinfo'>
                <div className="action-btn-block">
                  <button className='btn btn_primary' onClick={ this.handleBack }>Back</button>
                </div>
                <div className='info'>
                  <div className='left'>
                    <div className='groupimg' name="groupImage">
                      <Image imageToken = { userDetails.image } />
                    </div>
                    <div className='group'>
                      <div className='formgroup'>
                        <label>Name:</label>
                        <span>{ userDetails.name }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Email:</label>
                        <span>{ userDetails.emailId }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Registered Date:</label>
                        <span>{ registeredDate || `-` }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Last Login Date:</label>
                        <span>{ lastLoginDate || `-` }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Mobile:</label>
                        <span>{ userDetails.mobile || `-` }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Platform:</label>
                        <span>{ userDetails.deviceType || `web` } { ((userDetails.deviceType === 'android' || userDetails.deviceType === 'ios') ? userDetails.deviceVersion : '') }</span>
                      </div>
                      {userDetails.status === 1 ? 
                      <div className='formgroup'>
                        <button id="clear-user-data" className='btn btn_error' onClick={ (e) => this.handlePopup() }>Clear User Data</button>
                      </div>
                      :
                      '' }
                    </div>
                  </div>
                  {/* <div className='right'>
                    <div className='group'>
                      <div className='formgroup'>
                        <label>Mobile:</label>
                        <span>{ userDetails.mobile || `-` }</span>
                      </div>
                      <div className='formgroup'>
                        <label>Platform:</label>
                        <span>{ userDetails.deviceType || `web` } { ((userDetails.deviceType === 'android' || userDetails.deviceType === 'ios') ? userDetails.deviceVersion : '') }</span>
                      </div>
                      {userDetails.status === 1 ? 
                      <div className='formgroup'>
                        <button id="clear-user-data" className='btn btn_error' onClick={ (e) => this.handlePopup() }>Clear User Data</button>
                      </div>
                      :
                      '' }
                    </div>
                  </div> */}
                </div>
              </div>
              { deletepopup && <Popup popupText = 'Are you sure to clear this users data?' handleYes={ this.handleDelete } handleCancel={ this.closePopUp } /> }
            </div>
          </>
        )
    }
} 